import { useQuery } from '@tanstack/react-query';
import { getFavoriteExerciseSessions } from '../../../../api/diary-service';

const useFavoriteSessions = () => {
    return useQuery({
        queryKey: ['favoriteExerciseSessions'],
        queryFn: getFavoriteExerciseSessions,
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false
    });
};

export default useFavoriteSessions;
